
function normalizeCategory (category) {
  return category ? {
    slug: category.slug,
    name: category.name
  } : null
}

function normalizeSubCategory (subCategory) {
  return subCategory ? {
    slug: subCategory.slug,
    name: subCategory.name
  } : null
}

function normalizeChildren (children) {
  return children ? children.map(ResourceModel.fromJS) : null
}

export default class ResourceModel {
  id
  name
  descShort
  descMeta
  createdAt
  updatedAt
  url
  unlisted
  order
  category
  subCategory
  image // struct
  // children is either a list of ResourceModels,
  // or null (meaning none available, not necessarily no children)
  children
  highlight

  constructor (obj) {
    // Assume creation from JSON AJAX call
    const normalizedObj = ResourceModel.normalizeFromJS(obj)

    this.id = normalizedObj.id
    this.name = normalizedObj.name
    this.descShort = normalizedObj.descShort
    this.descMeta = normalizedObj.descMeta
    this.createdAt = normalizedObj.createdAt
    this.updatedAt = normalizedObj.updatedAt
    this.url = normalizedObj.url
    this.unlisted = normalizedObj.unlisted
    this.order = normalizedObj.order
    this.category = normalizedObj.category
    this.subCategory = normalizedObj.subCategory
    this.image = normalizedObj.image
    this.children = normalizedObj.children
    this.highlight = normalizedObj.highlight
  }

  get content () {
    return this.descShort
  }

  static normalizeFromJS (obj) {
    const image = {
      main: obj.details_image,
      tile: obj.tile_image,
      details: obj.details_image,
      width: obj.image_width,
      height: obj.image_height
    }

    const unlisted = !((!obj || obj.unlisted === 0))
    const category = normalizeCategory(obj.category)
    const subCategory = normalizeSubCategory(obj.sub_category)
    const children = normalizeChildren(obj.children)

    return {
      id: obj.id,
      name: obj.name,
      descShort: obj.desc_short,
      descMeta: obj.desc_meta,
      createdAt: obj.created_at,
      updatedAt: obj.updated_at,
      url: obj.url,
      unlisted,
      order: obj.order,
      category,
      subCategory,
      image,
      children,
      highlight: obj.highlight
    }
  }

  static fromJS (obj) {
    return new ResourceModel(obj)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/models/ResourceModel.js